import React, { useCallback, useEffect, useState } from 'react';
import cx from 'classnames';

import { ChipsItem } from '@atlas/ui';

import FilterChipItemList from 'components/Pages/Casino/Filter/FilterChipItemList';
import FilterSearch from 'components/Pages/Casino/Filter/FilterSearch';
import MultiFilter from 'components/Pages/Casino/Filter/MultiFilter/MultiFilter';

const Filter = ({ isSearchActive, setIsSearchActive, setShowFavorites, showFavorites }) => {
  const [shadowElement, setShadowElement] = useState('');

  const handleScroll = e => {
    const element = e.target;

    if (element.scrollTop > 150) {
      setShadowElement('shadow-onscroll');
    } else setShadowElement('');
  };

  useEffect(() => {
    const scrollElement = document.getElementsByClassName('layout-to-scroll')[0];

    scrollElement.addEventListener('scroll', handleScroll);

    return () => {
      scrollElement.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const openSearchHandler = useCallback(() => {
    setIsSearchActive(true);
  }, [setIsSearchActive]);

  const chipsListContainer = cx(
    'filter-buttons-and-search-container chips-list',
    { active: isSearchActive },
    shadowElement,
  );

  return (
    <>
      {isSearchActive ? (
        <FilterSearch isSearchActive={isSearchActive} setIsSearchActive={setIsSearchActive} />
      ) : (
        <div className={chipsListContainer}>
          <ChipsItem icon="search" onClick={openSearchHandler} />
          <MultiFilter disabled={showFavorites} />
          <FilterChipItemList setShowFavorites={setShowFavorites} showFavorites={showFavorites} />
        </div>
      )}
    </>
  );
};

export default Filter;
